import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-5a0a7cf4"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "change-plan"
};
var _hoisted_2 = {
  class: "content"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, "Your Plan", -1);
});

var _hoisted_4 = {
  class: "content"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, "Available Plans", -1);
});

import { onMounted, onUnmounted, ref } from 'vue';
import { apiGetCurrentSubscribe } from '@/api/information';
import { DATA_TYPE } from '@/utils/constData';
import { changePlanStatus } from '../data';
import Detail from './Detail/index.vue';
import { apiGetPrice } from '@/api/common';
import Pro from '../Pro/index.vue';
import Deep from '../Deep/index.vue';
import Free from '../Free.vue';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var currentData = ref({});
    var pageLoading = ref(true);

    function getCurrentSubscribe() {
      apiGetCurrentSubscribe().then(function (_ref) {
        var data = _ref.data;
        currentData.value = data || {};
      });
    }

    var initData = ref({});
    onMounted(function () {
      Promise.all([apiGetCurrentSubscribe(), apiGetPrice()]).then(function (result) {
        var _result$, _result$2;

        currentData.value = ((_result$ = result[0]) === null || _result$ === void 0 ? void 0 : _result$.data) || {};
        initData.value = (_result$2 = result[1]) === null || _result$2 === void 0 ? void 0 : _result$2.data;
      }).finally(function () {
        pageLoading.value = false;
      });
    });
    onUnmounted(function () {
      changePlanStatus.value = 0;
    });
    return function (_ctx, _cache) {
      var _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [!_unref(changePlanStatus) ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_withDirectives(_createElementVNode("div", _hoisted_2, [_hoisted_3, currentData.value.vipType === _unref(DATA_TYPE).PRO ? (_openBlock(), _createBlock(Pro, {
        key: 0,
        currentData: currentData.value,
        initData: initData.value,
        status: "your"
      }, null, 8, ["currentData", "initData"])) : _createCommentVNode("", true), currentData.value.vipType === _unref(DATA_TYPE).DEEP ? (_openBlock(), _createBlock(Deep, {
        key: 1,
        currentData: currentData.value,
        initData: initData.value,
        status: "your"
      }, null, 8, ["currentData", "initData"])) : _createCommentVNode("", true)], 512), [[_vShow, !pageLoading.value]]), _withDirectives(_createElementVNode("div", _hoisted_4, [_hoisted_5, currentData.value.vipType === _unref(DATA_TYPE).DEEP ? (_openBlock(), _createBlock(Pro, {
        key: 0,
        currentData: currentData.value,
        initData: initData.value,
        status: "available"
      }, null, 8, ["currentData", "initData"])) : _createCommentVNode("", true), _createVNode(Free, {
        currentData: currentData.value,
        initData: initData.value,
        status: "available"
      }, null, 8, ["currentData", "initData"])], 512), [[_vShow, !pageLoading.value]])], 64)) : (_openBlock(), _createBlock(Detail, {
        key: 1,
        currentData: currentData.value,
        initData: initData.value
      }, null, 8, ["currentData", "initData"]))])), [[_directive_loading, pageLoading.value]]);
    };
  }
});